import { useState, useEffect, useCallback, useRef } from 'react';
import { fetchTotalCountsAction } from '../../actions/dashboardActions';
import { toast } from 'react-toastify';

/**
 * Dashboard statistics configuration
 */
export const dashboardStatsConfig = [
    {
        key: 'totalClients',
        title: 'Total Clients',
        icon: '👥',
        color: '#4a90e2',
        filterKey: 'entityCategory',
        filterValue: 'client',
    },
    {
        key: 'totalVendors',
        title: 'Total Vendors',
        icon: '🏢',
        color: '#f39c12',
        filterKey: 'entityCategory',
        filterValue: 'vendor',
    },
    {
        key: 'totalPendings',
        title: 'Pending',
        icon: '📊',
        color: '#e74c3c',
        filterKey: 'documentStatus',
        filterValue: 'pending',
    }
];


export const getFormattedStatValue = (value, isLoading) => {
    if (isLoading) return '...';
    if (value === null || value === undefined) return '0';
    return value.toString();
};

export const useDashboardCounts = () => {
    const [counts, setCounts] = useState({
        totalClients: 0,
        totalVendors: 0,
        totalPendings: 0
    });
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const isLoadingRef = useRef(false);

    const loadDashboardCounts = useCallback(async (cancelled = { current: false }) => {

        isLoadingRef.current = true;
        setIsLoading(true);
        setError(null);

        try {
            console.log('[Dashboard] Fetching total counts');
            const response = await fetchTotalCountsAction();
            if (cancelled.current) return;

            if (response.success) {
                setCounts(response.data);
                console.log('[Dashboard] Counts loaded:', response.data);
            } else {
                const errorMsg = response.message || "Failed to load dashboard counts";
                setError(errorMsg);
                toast.error(errorMsg);
            }
        } catch (err) {
            if (cancelled.current) return;
            const errorMsg = "Failed to load dashboard counts";
            setError(errorMsg);
            toast.error(errorMsg);
        } finally {
            if (!cancelled.current) setIsLoading(false);
            isLoadingRef.current = false;
        }
    }, []);

    useEffect(() => {
        const cancelled = { current: false };
        loadDashboardCounts(cancelled);
        return () => { cancelled.current = true; };
    }, [loadDashboardCounts]);

    return {
        counts,
        isLoading,
        error,
        refetch: loadDashboardCounts
    };
};



export const getStatsArray = (counts, isLoading) => {
    return dashboardStatsConfig.map(config => ({
        ...config,
        value: getFormattedStatValue(counts[config.key], isLoading)
    }));
};

